/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessInfoDto } from '../../models/business-info-dto';
import { UpdateBusinessInfoDto } from '../../models/update-business-info-dto';

export interface BusinessInfoControllerUpdate$Params {
      body: UpdateBusinessInfoDto
}

export function businessInfoControllerUpdate(http: HttpClient, rootUrl: string, params: BusinessInfoControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BusinessInfoDto>> {
  const rb = new RequestBuilder(rootUrl, businessInfoControllerUpdate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BusinessInfoDto>;
    })
  );
}

businessInfoControllerUpdate.PATH = '/api/businessInfo';
